export enum WALLET_TRANSACTION_TYPES {
  DEBIT = 'DEBIT',
  AUTO_REFILL = 'AUTO_REFILL',
  REFUND = 'REFUND',
}

export enum WALLET_TRANSACTION_CONTENT_TYPES {
  LESSONS = 'LESSONS',
}

export const WALLET_AUTO_REFILL_AMOUNT = 25;

export const LESSON_UNLOCK_DEBIT_AMOUNT = 20;

export const WALLET_DAYS_BETWEEN_REFILL = 30;

export const LESSON_ALLOW_INVALIDATE_UNLOCK_DELAY = 1;

export const DISCOVERY_UNLOCK_LESSONS_PERCENTAGE = 30;

/** Mongoose model metadata owned by the wallet bounded context. */
export const WALLET_MODEL = {
  MODEL_NAME: 'Wallet',
  COLLECTION_NAME: 'Wallets',
} as const;

/** Mongoose model name of the User aggregate referenced by wallet. */
export const USER_MODEL_NAME = 'User';
export * from './error-codes';
